import {IconIsActive} from '../../../components/IconIsActive'
import {TooltipWrapper as Tooltip} from '../../../components/Tooltip'
import {isColorDark} from '../../../utils/isColorDark'
import {phoneMask} from '../../../utils/phoneMask'

const TooltipWrapper = ({observation, children}) => {
  if (!observation) {
    return children
  }
  return (
    <Tooltip tooltipText={observation} tooltipPlacement={'top'}>
      {children}
    </Tooltip>
  )
}

export const EventComponent = ({event}) => (
  <div style={{display: 'flex', alignItems: 'start'}}>
    {event.client?.activeAlert && <IconIsActive text={event.client?.alerts?.[0]?.observation} />}
    <TooltipWrapper observation={event.observation}>
      <div
        className='row fw-bold'
        style={{
          color:
            event.highlight === 1
              ? isColorDark(event.colorStatus)
                ? '#fa8484'
                : 'red'
              : isColorDark(event.colorStatus)
              ? 'white'
              : 'black',
        }}
      >
        <div className='col-12'>
          <small>{event.client?.physicalPerson?.preferredName ?? event.client?.name}</small>
        </div>
        <div className='col-12'>
          <small>{phoneMask(event.client?.contacts[0]?.phone)}</small>
        </div>
        <div className='col-12'>
          {event.items.map((data, index) => (
            <tr key={index} style={{fontSize: '11px'}}>
              <td>
                {data.saleItem?.product?.name
                  ? data.saleItem?.product?.name
                  : data.evaluationProduct?.name}
              </td>
              <td>
                {data.sessionNumber} /{' '}
                {data.saleItem?.product?.name ? data.saleItem?.sessions : '1'}
              </td>
            </tr>
          ))}
        </div>
      </div>
    </TooltipWrapper>
  </div>
)
